import React from "react";
import styled from "styled-components";
import { colors2 } from "oolib";
import { UI_TAG, UI_CAPTION_DF } from "oolib/dist/v2/components/Typo2";

/**
 * A small rounded pill in the row's own colours (via dynamicPropsCallback).
 *
 * Two looks from the same block:
 *   - the default: filled (`bg`), uppercase tag text (`color`) — the zone /
 *     signal-category pill the dashboard uses;
 *   - `dot`: a grey pill with a coloured circle before title-case text —
 *     for a value whose identity is a colour (a signal in its category's
 *     accent) without shouting. `uppercase: false` on its own also works.
 * `hint` is the title.
 */
const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$color};
  white-space: nowrap;
  max-width: 100%;
  min-width: 0;
`;
const Dot = styled.span`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: ${(p) => p.$color};
  flex-shrink: 0;
`;
const Ellipsis = { overflow: "hidden", textOverflow: "ellipsis", color: "inherit" };

const TablePill = ({ value, bg, color, dot, uppercase, hint }) => {
  if (!value) return null;
  const upper = uppercase ?? !dot;
  const Typo = upper ? UI_TAG : UI_CAPTION_DF;
  return (
    <Pill title={hint || undefined} $bg={bg || (dot ? colors2.grey5 : colors2.grey10)} $color={color || colors2.grey80}>
      {dot && <Dot $color={dot} />}
      <Typo style={Ellipsis}>{value}</Typo>
    </Pill>
  );
};

export default TablePill;
